import { merge as _merge } from 'lodash'
import es from 'core/translations/es'

export default _merge(es, {
  serverError: {
    INVALID_SERIAL: 'Código no válido: debe tener 18 dígitos.',
    PRODUCTION_ORDER_NOT_FOUND: 'No se ha encontrado ninguna orden de producción para este código.',
    STYLE_MATERIAL_COLOR_MISMATCH: 'El modelo, parte o color del artículo no coincide con la línea del pedido de producción.',
    SCONNECT_SHIPMENT_FAILED: 'No se pudo enviar el envío a S-Connect.'
  },
  otb_outbound: {
    scan_title: 'Escanear código de pedido de producción (18 dígitos)',
    scan_code_label: 'Código',
    select_title: 'Seleccionar pedido de producción',
    header_label: 'Pedido de producción',
    pdf_title: 'Etiqueta PDF',
    pdf_downloaded: 'Etiqueta del bulto descargada',
    pdf_error: 'No se pudo generar o descargar la etiqueta PDF',
    pdf_parcel_unavailable: 'Bulto confirmado, pero no se pudo recuperar para descargar la etiqueta PDF'
  }
})
